/** Product name. A brand, not a phrase: never translated, identical in every language. */
export const BRAND = "Poruch";
